import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { saveMemberInfo } from '../../../redux/reducers/member';
import {
    getMABAA010ExcelCheckStatus,
    getMABAA010ExcelDownload,
    postMABAA010,
    postMABAA010Excel,
    getAdminLoginUser,
    deleteMABAA010
} from '../../../services/Api';
import { DOMAIN_USER, MESSAGE } from '../../../shared/constants/app';
import CheckGroup from '../../../shared/components/CheckGroup';
import Loader from '../../../shared/components/Loader';
import Pagination from '../../../shared/components/Pagination';
import SideMenu from '../../../shared/components/SideMenu';
import { MENU_MEMBERS } from '../../../shared/constants/app';
import { formatDate, formatNumberWithCommas, getCheckBoxValues } from '../../../utils';

const MABAA010 = () => {
    const [data, setData] = useState({});
    const [showDetails, setShowDetails] = useState(false);
    const [checkedValues, setCheckedValues] = useState({});
    const [checkedStatusCommon, setCheckedStatusCommon] = useState([]);
    const [memberStatistics, setMemberStatistics] = useState([]);

    const [searchCondition, setSearchCondition] = useState('');
    const [keyword, setKeyword] = useState('');
    const [size, setSize] = useState(50);
    const [listResults, setListResults] = useState([]);

    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [pages, setPages] = useState({});

    const dispatch = useDispatch();

    const toggleDetails = () => setShowDetails(!showDetails);

    const getOptions = (name) => {
        const options = {
            MemberGbn: [
                { id: 'MemberGbn_C', label: '치과회원', value: 'c' },
                { id: 'MemberGbn_P', label: '개인회원', value: 'p' },
            ],
            AppGbnCD: [
                { id: 'AppGbnCD_110', label: '치과의사', value: '110' },
                { id: 'AppGbnCD_201', label: '치과기공사(소장)', value: '201' },
                { id: 'AppGbnCD_202', label: '치과기공사(기사)', value: '202' },
                { id: 'AppGbnCD_310', label: '치과위생사 및 진료스텝', value: '310' },
                { id: 'AppGbnCD_401', label: '학생(치의학과)', value: '401' },
                { id: 'AppGbnCD_402', label: '학생(치위생사)', value: '402' },
                { id: 'AppGbnCD_403', label: '학생(치기공사)', value: '403' },
                { id: 'AppGbnCD_999', label: '기타', value: '999' },
            ],
            EM_join_membership: [
                { id: 'EM_join_membership_1', label: '있음', value: '1' },
                { id: 'EM_join_membership_2', label: '없음', value: '2' },
            ],
            MemberStatus: [
                { id: 'MemberStatus_ACTIVATE', label: '활성', value: 'ACTIVATE' },
                { id: 'MemberStatus_PAUSE', label: '휴면', value: 'PAUSE' },
                { id: 'MemberStatus_LOCK', label: '차단', value: 'LOCK' },
            ],
        };
        return options[name];
    };

    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;
        if (name !== 'MemberStatus') {
            setCheckedValues((checkedValues) => getCheckBoxValues(checkedValues, name, value, checked));
        } else if (name === 'MemberStatus') {
            setCheckedStatusCommon((prevStatusCommon) => {
                const statusCommon = [...prevStatusCommon];
                if (checked) {
                    statusCommon.push(value);
                } else {
                    const index = statusCommon.indexOf(value);
                    if (index > -1) {
                        statusCommon.splice(index, 1);
                    }
                }
                return statusCommon;
            });
        }
    };

    const getSearchCondition = (e) => {
        const selectedValue = e.target.value;
        setSearchCondition(selectedValue);
    };

    const inputChange = (e) => {
        setKeyword(e.target.value);
    };

    const getSize = (e) => {
        const selectedValue = e.target.value;
        setSize(selectedValue);
    };

    const [loading, setLoading] = useState(false);

    const appGbnCDMapping = {
        110: '치과의사',
        201: '치과기공사(소장)',
        202: '치과기공사(기사)',
        310: '치과위생사 및 진료스텝',
        401: '학생(치의학과)',
        402: '학생(치위생사)',
        403: '학생(치기공사)',
        999: '기타',
        100: '전체',
    };

    const getListData = (currentPage = page, reset) => {
        postMABAA010({
            searchCondition,
            keyword: reset ? '' : keyword?.trim(),
            options: reset ? {} : checkedValues,
            statusCommon: reset ? [] : checkedStatusCommon,
            size,
            page: currentPage,
        })
            .then(({ data }) => {
                setListResults(data.data);
                setPages(data.info);
                setMemberStatistics(data.statisticMembers);
            })
            .catch((error) => console.log(error));
    };

    const clickReset = () => {
        setSearchCondition('');
        setKeyword('');
        setCheckedValues({});
        setCheckedStatusCommon([]);
        setSearchParams({ page: 1 });
        getListData(1, true);
    };

    const clickSearch = () => {
        setSearchParams({ page: 1 });
        getListData(1);
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            clickSearch();
        }
    };
    useEffect(() => {
        getListData();
        // eslint-disable-next-line
    }, [page, size]);

    // const getType = (e) => {
    //     const type = e.target.value;
    //     setTypeDownload(type);
    // };

    const handleDownloadExcel = async () => {
        setLoading(true);
        try {
            // Step 1
            const { data: id } = await postMABAA010Excel(
                {
                    searchCondition,
                    keyword,
                    options: checkedValues,
                    statusCommon: checkedStatusCommon,
                    size,
                    page,
                },
                'xlsx',
            );

            // Step 2
            let status = 'Processing';
            while (status === 'Processing') {
                await new Promise((resolve) => setTimeout(resolve, 20000));
                const { data } = await getMABAA010ExcelCheckStatus(id);
                status = data;
            }

            // Step 3
            const { data: fileData } = await getMABAA010ExcelDownload(status);
            const url = window.URL.createObjectURL(new Blob([fileData]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `회원 리스트.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleSaveMemberInfo = (memberGbn, seq, nameKor) => {
        dispatch(saveMemberInfo({ seq, memberGbn, nameKor }));
    };

    const handleOpenUser = async (e, memberID) => {
        e.preventDefault();
        const adminResponse = await getAdminLoginUser({ params: { memberID } });
        const url = DOMAIN_USER + '/auth-redirect?token=' + adminResponse.data;
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    const handleDeleteMember = async (e, memberID) => {
        e.preventDefault();
        if (window.confirm(MESSAGE.confirm.delete)) {
            try {
                await deleteMABAA010(memberID);
                window.alert(MESSAGE.notify.deleteSuccess);
                getListData();
            } catch (error) {
                console.error(error);
                window.alert(MESSAGE.notify.deleteError);
            }
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [searchParams]);
    return (
        <div className="container">
            <div className="wrap">
                <SideMenu menu={MENU_MEMBERS} />
                <div className="content-right">
                    <h1 className="title">등록회원</h1>
                    <table id="table-form-option" className="table table-bordered table-has-radius">
                        <tbody>
                            <tr>
                                <th colSpan={8} className="t-left header-item">
                                    <div className="header-item-inner">
                                        <div className="select-box">
                                            <select onChange={getSearchCondition} value={searchCondition}>
                                                <option value="">전체</option>
                                                <option value="MemberID">아이디</option>
                                                <option value="NameKor">이름</option>
                                                <option value="ResidentNo">생년월일(YYMMDD)</option>
                                                <option value="BizCompany">치과명</option>
                                                <option value="LicenseNo">면허번호</option>
                                                <option value="TelNo">연락처</option>
                                                <option value="MobileNo">핸드폰</option>
                                                <option value="Email">이메일</option>
                                            </select>
                                            <input
                                                type="text"
                                                placeholder="검색어를 입력해 주세요."
                                                onChange={inputChange}
                                                value={keyword}
                                                onKeyDown={handleKeyDown}
                                            />
                                        </div>
                                        <div className="button-group">
                                            <button className="btn btn-primary" onClick={clickSearch}>
                                                검색
                                            </button>
                                            <button className="btn btn-gray-thin" onClick={clickReset}>
                                                초기화
                                            </button>
                                            <button className="btn btn-dark" onClick={toggleDetails}>
                                                상세검색
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                            {showDetails && (
                                <>
                                    <tr>
                                        <th colSpan={1}>
                                            <span>회원그룹</span>
                                        </th>
                                        <td colSpan={7}>
                                            <div>
                                                <CheckGroup
                                                    name="MemberGbn"
                                                    options={getOptions('MemberGbn')}
                                                    checkedValues={checkedValues.MemberGbn}
                                                    onChange={handleCheckboxChange}
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th colSpan={1}>
                                            <span>회원구분</span>
                                        </th>
                                        <td colSpan={7}>
                                            <div
                                                className="group-checkBox"
                                                style={{ gridTemplateColumns: 'repeat(6, auto)' }}
                                            >
                                                <CheckGroup
                                                    name="AppGbnCD"
                                                    options={getOptions('AppGbnCD')}
                                                    checkedValues={checkedValues.AppGbnCD}
                                                    onChange={handleCheckboxChange}
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <span>상태</span>
                                        </th>
                                        <td style={{ maxWidth: 619 }}>
                                            <div>
                                                <CheckGroup
                                                    name="MemberStatus"
                                                    options={getOptions('MemberStatus')}
                                                    checkedValues={checkedStatusCommon}
                                                    onChange={handleCheckboxChange}
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                        <th colSpan={1} style={{ width: 201 }}>
                                            <span>DVmall 회원멤버십</span>
                                        </th>
                                        <td colSpan={3} style={{ width: 420 }}>
                                            <div>
                                                <CheckGroup
                                                    name="EM_join_membership"
                                                    options={getOptions('EM_join_membership')}
                                                    checkedValues={checkedValues.EM_join_membership}
                                                    onChange={handleCheckboxChange}
                                                    type="checkbox"
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                </>
                            )}
                        </tbody>
                    </table>
                    <table id="table-results" className="table table-bordered table-has-radius">
                        <thead>
                            <tr>
                                {memberStatistics.map((data, index) => (
                                    <th key={'memberStatistics' + index}>
                                        <div>{appGbnCDMapping[data.appGbnCD]}</div>
                                        <div className="count" style={{ color: '#00f' }}>
                                            ({formatNumberWithCommas(data.intlCnt + data.actCnt)})
                                        </div>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                {memberStatistics.map((data, index) => (
                                    <td key={'statistics' + index}>
                                        <div>
                                            <span style={{ color: '#00f' }}>통합</span>:{' '}
                                            <span style={{ color: '#00f' }}>
                                                {formatNumberWithCommas(data.intlCnt)}
                                            </span>
                                        </div>
                                        <div>
                                            <span style={{ color: '#00f' }}>미통합</span>:{' '}
                                            <span style={{ color: '#00f' }}>{formatNumberWithCommas(data.actCnt)}</span>
                                        </div>
                                        <div>
                                            <span>휴면</span>: <span>{formatNumberWithCommas(data.slpCnt)}</span>
                                        </div>
                                    </td>
                                ))}
                            </tr>
                        </tbody>
                    </table>
                    <div className="wrap-dropDown">
                        <div className="collab">
                            <div className="button-group">
                                <button
                                    className="btn btn-success"
                                    style={{ width: 176, height: 38 }}
                                    onClick={handleDownloadExcel}
                                    disabled={loading}
                                >
                                    {loading ? <Loader /> : '활성회원 엑셀 다운로드'}
                                </button>
                                {/* <select className="select-basic" onChange={getType}>
                                    <option value="csv">.csv</option>
                                    <option value="xlsx">.xlsx</option>
                                </select> */}
                            </div>
                        </div>
                        <div className="collab">
                            <div className="form-select-container">
                                <select className="select-basic" onChange={getSize} defaultValue={50}>
                                    <option value="20">20개씩 보기</option>
                                    <option className="option-placeholder" value="50">
                                        50개씩 보기
                                    </option>
                                    <option value="100">100개씩 보기</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <table
                        id="table-results-member"
                        className="table table-results-member-style1 table-bordered table-has-radius"
                    >
                        <thead>
                            <tr>
                                <td colSpan={14}>
                                    <div className="top-table">
                                        <div className="count-case">
                                            총 {formatNumberWithCommas(pages?.totalRow || 0)}건
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <th>상태</th>
                                <th style={{ width: '70px' }}>회원 그룹</th>
                                <th>회원아이디</th>
                                <th>이름</th>
                                <th>생년월일</th>
                                <th>핸드폰</th>
                                <th>회원 구분</th>
                                <th>치과명</th>
                                <th>면허번호</th>
                                <th>DV Point</th>
                                <th>통합여부</th>
                                <th>가입일</th>
                            </tr>
                            {listResults && listResults?.length > 0 ? (
                                listResults.map((item, index) => {
                                    return (
                                        <tr key={index}>
                                            <td
                                                className={
                                                    item?.memberStatus === '활성'
                                                        ? 'blue'
                                                        : '' || item?.memberStatus === '휴면'
                                                            ? 'yellow'
                                                            : '' || item?.memberStatus === '차단'
                                                                ? 'red'
                                                                : ''
                                                }
                                            >
                                                {item?.memberStatus}
                                            </td>
                                            <td>{item?.memberGbn === 'P' ? '개인' : '치과'}</td>
                                            <td style={{ position: 'relative' }}>
                                                {item?.memberStatus === '휴면' ? (
                                                    <>
                                                        <span style={{ position: 'relative', top: '-10px' }}>
                                                            {item.memberID}
                                                        </span>
                                                        <Link onClick={(e) => handleDeleteMember(e, item?.memberID)}>
                                                            <i className="icon icon-del" />
                                                        </Link>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Link
                                                            style={{ position: 'relative', top: '-10px' }}
                                                            to={
                                                                item?.memberStatus01 === ''
                                                                    ? `/mabaa031-${item.seq}?tbl=${item.tbl}&gbn=${item.memberGbn}`
                                                                    : item?.memberGbn === 'P'
                                                                        ? `/mabaa030-${item.seq}?tbl=${item.tbl}&gbn=${item.memberGbn}`
                                                                        : `/mabaa070-${item.seq}?tbl=${item.tbl}&gbn=${item.memberGbn}`
                                                            }
                                                            onClick={() =>
                                                                handleSaveMemberInfo(item.memberGbn, item.seq, item.nameKor)
                                                            }
                                                        >
                                                            {item.memberID}
                                                        </Link>
                                                        <Link onClick={(e) => handleOpenUser(e, item?.memberID)}>
                                                            <i className="icon icon-blank" />
                                                        </Link>
                                                    </>
                                                )}
                                            </td>
                                            <td>
                                                {item?.memberStatus === '휴면' ? (
                                                    item.nameKor
                                                ) : (
                                                    <Link
                                                        to={
                                                            item?.memberStatus01 !== 'INTL'
                                                                ? `/mabaa031-${item.seq}?tbl=${item.tbl}&gbn=${item.memberGbn}`
                                                                : item.memberGbn === 'P'
                                                                    ? `/mabaa030-${item.seq}?tbl=${item.tbl}&gbn=${item.memberGbn}`
                                                                    : `/mabaa070-${item.seq}?tbl=${item.tbl}&gbn=${item.memberGbn}`
                                                        }
                                                        onClick={() =>
                                                            handleSaveMemberInfo(item.memberGbn, item.seq, item.nameKor)
                                                        }
                                                    >
                                                        {item.nameKor}
                                                    </Link>
                                                )}
                                            </td>
                                            <td>{formatDate(item?.residentNo)}</td>
                                            <td>{item.mobileNo || '-'}</td>
                                            <td>{appGbnCDMapping[item?.appGbnCD] || ''}</td>
                                            <td>{item.bizCompany || '-'}</td>
                                            <td>{item.licenseNo}</td>
                                            <td>{item.dvpoint || '-'}</td>
                                            <td className={item.memberStatus01 === 'INTL' ? 'blue' : ''}>
                                                {item?.memberStatus01 === 'INTL' ? '통합' : '미통합'}
                                            </td>
                                            <td>{formatDate(item?.regDate)}</td>
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={12}>데이타가 없습니다.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    <Pagination pages={pages} />
                </div>
            </div>
        </div>
    );
};

export default MABAA010;
